var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3662",
    viewBox: "0 0 45.582 38.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    fillRule: "evenodd",
    transform: "translate(-274.35 -433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2419",
    d: "m296.93 471.6-0.006-17.12-8.3522-10.534-7.0924 6.3955 0.8078 16.608 14.643 4.6498z",
    fill: "#9da7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2421",
    d: "m296.93 471.6-0.004-17.278 15.485-4.1491-0.2221 15.288-15.259 6.1387z",
    fill: "#757e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2473",
    strokeLinejoin: "bevel",
    d: "m278.05 452.48 10.662-9.0656 11.217 15.143 16.149-6.0774-9.7239-11.287-17.711 2.1511-10.592 9.1355z",
    stroke: "#67686b",
    strokeWidth: "1px",
    fill: "#67686b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3251",
    d: "m286.66 468.24-0.68076-10.984 5.3379 1.1523-0.25873 11.125-4.3984-1.2936z",
    fill: "#67686b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25 0 0 -1.25 0 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6008",
    transform: "matrix(.32503 0 0 .32503 -100.86 -132.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5704",
    transform: "translate(362.96 472.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5706",
    fillRule: "evenodd",
    fill: "#6f6c6d",
    d: "m0 0c0-4.93-3.997-8.927-8.927-8.927-4.929 0-8.927 3.997-8.927 8.927s3.998 8.927 8.927 8.927c4.93 0 8.927-3.997 8.927-8.927"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5708",
    transform: "translate(362.69 459.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5710",
    fillRule: "evenodd",
    fill: "#6f6c6d",
    d: "m0 0c-1.353 0.946-3.808 1.721-5.458 1.721h-6c-1.65 0-4.105-0.775-5.458-1.721l-0.084-0.059c-1.353-0.946-2.458-3.07-2.458-4.72v-11.625c0-1.651 0.562-4.097 1.25-5.438 0.687-1.341 1.475-2.437 1.75-2.437s0.722-1.332 0.993-2.959l2.014-12.082c0.271-1.627 1.506-2.959 2.743-2.959h4.5c1.237 0 2.472 1.332 2.743 2.959l2.014 12.082c0.271 1.627 0.718 2.959 0.993 2.959s1.062 1.096 1.75 2.437c0.687 1.341 1.25 3.787 1.25 5.438v11.625c0 1.65-1.105 3.774-2.458 4.72l-0.084 0.059z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse2);
export default __webpack_public_path__ + "static/media/house2.bd787c2b3c26f074413c550ad74e0502.svg";
export { ForwardRef as ReactComponent };